<div class="company-product-phase-time-compliance-details">
  <h4 class="details-title">Horas por fase</h4>

  @if (phaseTypeSummaries().length === 0) {
    <p class="no-data">{{ emptyMessage() }}</p>
  } @else {
    @for (phase of phaseTypeSummaries(); track phase.company_product_phase_type_slug) {
      <section class="phase-block">
        <div class="summary-row">
          <span class="summary-label">{{ phase.company_product_phase_type_name }}</span>
          <span class="summary-value">
            <span class="summary-hours" matTooltip="Horas registradas" matTooltipPosition="above" matTooltipShowDelay="300"
              >{{ phase.done_hours | number: '1.0-0' }}h</span
            >/<span class="summary-hours" matTooltip="Horas esperadas" matTooltipPosition="above" matTooltipShowDelay="300"
              >{{ phase.expected_hours | number: '1.0-0' }}h</span
            >
          </span>
        </div>

        @if (phase.weeks.length > 0) {
          <table class="weeks-table">
            <thead>
              <tr>
                <th class="week-range">Semana</th>
                <th class="week-hours">Horas hechas / esperadas</th>
                <th class="week-status">Estado</th>
              </tr>
            </thead>
            <tbody>
              @for (week of phase.weeks; track week.week_start) {
                <tr>
                  <td class="week-range">Del {{ week.week_start | date: 'd/M' : 'UTC' }} al {{ week.week_end | date: 'd/M' : 'UTC' }}</td>
                  <td class="week-hours">
                    {{ week.done_hours | hourDecimalToHoursMinutes }} / {{ week.expected_hours | hourDecimalToHoursMinutes }}
                  </td>
                  <td class="week-status">
                    <span class="status-cell">
                      <span class="status-label" [class.is-correct]="week.is_correct" [class.is-incorrect]="!week.is_correct">
                        {{ week.is_correct ? 'Correcto' : 'Incorrecto' }}
                      </span>
                      <mat-icon
                        class="info-icon"
                        [matTooltip]="week.status_tooltip"
                        matTooltipPosition="above"
                        matTooltipShowDelay="200"
                        matTooltipClass="kpi-tooltip"
                      >
                        info
                      </mat-icon>
                    </span>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        }
      </section>
    }
  }
</div>
